import BaseController from './base';
import { parseString, formatNumber, isBlank } from '../../commons'
export default class extends BaseController {

  static targets = [
    "duration", "rate", "amount"
  ]

  user_changed(e) {
    var rate = e.target.options[e.target.selectedIndex].dataset.hourlyRate
    this.rateTarget.value = rate
    this.recompute()
  }

  recompute() {
    let duration = parseString(this.durationTarget.value)
    let hourly_rate = parseString(this.rateTarget.value)
    this.amountTarget.value = formatNumber((duration / 60) * hourly_rate)
  }

  nature_changed(e) {
    var duration = e.target.options[e.target.selectedIndex].dataset.defaultDuration
    if (!isBlank(duration)) {
      this.durationTarget.value = duration
      this.recompute()
    }
  }

}
